// extracted by mini-css-extract-plugin
export default {"info_container":"Info_info_container__C4n-Q","info_all":"Info_info_all__i+bD6","info_wrapper":"Info_info_wrapper__B+7e0","mega_phone":"Info_mega_phone__2iUUp"};